import { render } from "./ViewRecords.vue?vue&type=template&id=706ad832&scoped=true&ts=true"
import script from "./ViewRecords.vue?vue&type=script&lang=ts"
export * from "./ViewRecords.vue?vue&type=script&lang=ts"

import "./ViewRecords.vue?vue&type=style&index=0&id=706ad832&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706ad832"]])

export default __exports__